/**
 * @desc 保存或编辑时效设置
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: Array<defs.tms.SiteEfficiencyMasterRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
